"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartStrategyProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useFeatureFlag_1 = require("../../hooks/useFeatureFlag");
const hooks_1 = require("../hooks");
const isGenericReseller_1 = require("../../utils/helpers/isGenericReseller");
const envConfig_1 = require("../../utils/helpers/config/envConfig");
const types_1 = require("../../types");
const ONLINE_CART_FEATURE_FLAG_KEY = 'enableonlinecart';
const BUSINESS_UNIT = types_1.BusinessUnit[envConfig_1.envConfig.currentBrand];
const CartStrategyProvider = ({ children, resellerSlug, state, cycle, }) => {
    const onlineCart = (0, hooks_1.useOnlineCart)();
    const localCart = (0, hooks_1.useLocalCart)();
    const [isCartOnlineEnabled, isFlagLoading] = (0, useFeatureFlag_1.useFeatureFlag)(ONLINE_CART_FEATURE_FLAG_KEY);
    const loadOnlineCart = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield onlineCart.loadCart();
        }
        catch (_a) {
            yield onlineCart
                .createCart({
                catalogSlug: (0, isGenericReseller_1.isGenericReseller)(resellerSlug) ? '' : resellerSlug,
                state: state !== null && state !== void 0 ? state : '',
                cycle: Number(cycle),
                businessUnit: BUSINESS_UNIT,
            })
                .catch(() => {
                localCart.createCart();
            });
        }
    });
    (0, react_1.useEffect)(() => {
        if (isFlagLoading) {
            return;
        }
        if (isCartOnlineEnabled) {
            if (!resellerSlug || !state || !cycle) {
                console.error('resellerSlug, state and cycle are required to use online cart');
                return;
            }
            loadOnlineCart();
            return;
        }
        localCart.loadCart();
    }, [isCartOnlineEnabled, isFlagLoading]);
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
};
exports.CartStrategyProvider = CartStrategyProvider;
